import React from 'react';
import { Link } from 'react-router-dom';
import './YociLabHub.css';
import SEO from '../components/SEO';

// Workspace & Event Photos
import boardroomImg from '../assets/YOCILAB/Board room.11ff75e0c48c951770f2.jpg';
import dayOfficeImg from '../assets/YOCILAB/Day office.6d707ab2dcc230c554a0 (1).jpg';
import techVibesImg from '../assets/YOCILAB/digital tech initiative_051535.JPG';
import incubatorImg from '../assets/YOCILAB/Entrepreneurship and innovation.jpg';
import creativeSpaceImg from '../assets/YOCILAB Webiste photos/YOCILAB Creative Space/Creative space.jpg';
import dscImg from '../assets/YOCILAB Webiste photos/YOCILAB Creative Space/DSC_3120.jpg';

const amenities = [
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
    title: "Uninterrupted Power",
    desc: "Reliable solar & generator backup power to keep your workflow uninterrupted."
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/>
      </svg>
    ),
    title: "High-Speed Fiber",
    desc: "Gigabit-speed dedicated internet for development, streaming, and global calls."
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
      </svg>
    ),
    title: "Creator & Podcast Booth",
    desc: "Acoustic-treated studio with podcast mics and lighting for content creators."
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: "Collaborative Meeting Rooms",
    desc: "Smart displays and video-conferencing setups for team sprints and client pitches."
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>
      </svg>
    ),
    title: "Cafe & Networking Lounge",
    desc: "Open lounge for serendipitous collisions, fresh coffee, and peer knowledge sharing."
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    ),
    title: "Mentorship & Investor Access",
    desc: "On-site office hours with venture mentors, technical coaches, and angel investors."
  }
];

const passes = [
  {
    tier: "Day Builder",
    price: "$5",
    period: "/ day",
    desc: "Perfect for freelancers and builders needing high-speed workspace for a productive sprint.",
    features: [
      "Access to open co-working desks",
      "High-speed fiber internet",
      "Coffee & lounge access",
      "Community event invitations"
    ],
    popular: false,
    cta: "Get Day Pass"
  },
  {
    tier: "Resident Innovator",
    price: "$60",
    period: "/ month",
    desc: "For dedicated founders, developers, and creators scaling active ventures.",
    features: [
      "Dedicated desk & locker storage",
      "Unlimited 24/7 hub access",
      "5 hours meeting room credits / mo",
      "Access to Creator & Podcast booth",
      "Direct 1-on-1 mentor matching",
      "Discounts on YOCILAB Academy"
    ],
    popular: true,
    cta: "Join as Resident"
  },
  {
    tier: "Startup Team Studio",
    price: "$200",
    period: "/ month",
    desc: "Private cluster for early-stage teams building products and closing seed rounds.",
    features: [
      "Private 4-6 desk team suite",
      "Unlimited meeting room access",
      "Venture incubator fast-track",
      "Investor pitch day showcase",
      "Priority demo booth at Youth Summit"
    ],
    popular: false,
    cta: "Apply for Team Suite"
  }
];

const YociLabHub = () => {
  return (
    <div className="yocilab-hub-page">
      <SEO
        title="Creative Space & Hub | YOCILAB"
        description="A vibrant physical launchpad in Cameroon for youth-led experimentation, co-working, technology learning, and startup incubation."
      />

      {/* Hero Section */}
      <section className="hub-hero">
        <div className="hub-hero__bg-wrap">
          <img src={creativeSpaceImg} alt="YOCILAB Creative Hub Space" className="hub-hero__bg" />
          <div className="hub-hero__overlay" />
        </div>
        <div className="container">
          <div className="hub-hero__badge">
            <span className="hub-hero__badge-dot" />
            PHYSICAL INNOVATION LAUNCHPAD
          </div>
          <h1 className="hub-hero__title">
            Where Bold African Ideas<br />
            <em>Become Reality</em>
          </h1>
          <p className="hub-hero__subtitle">
            A dynamic co-working, prototyping, and creator sanctuary designed for young innovators to collaborate, build, and thrive.
          </p>
        </div>
      </section>

      {/* Pillars / Wings */}
      <section className="hub-wings-section">
        <div className="container">
          <div className="hub-section-header text-center">
            <span className="section-pill">OUR INTEGRATED FACILITIES</span>
            <h2>What Happens Inside the Hub</h2>
            <p>Four interconnected wings engineered to support creators at every stage of their builder journey.</p>
          </div>

          <div className="hub-wings-grid">
            {/* Wing 1: Co-working */}
            <div className="hub-wing-card">
              <div className="hub-wing-img-wrap">
                <img src={dayOfficeImg} alt="Co-working Space" className="hub-wing-img" />
                <span className="hub-wing-tag">WORKSPACE</span>
              </div>
              <div className="hub-wing-body">
                <h3>Co-working & Collaboration Space</h3>
                <p>
                  Flexible hot desks, ergonomic dedicated pods, private soundproof booths, and collaborative communal tables powered by enterprise fiber wifi and solar backup.
                </p>
              </div>
            </div>

            {/* Wing 2: TechVibes */}
            <div className="hub-wing-card">
              <div className="hub-wing-img-wrap">
                <img src={techVibesImg} alt="TechVibes Digital Labs" className="hub-wing-img" />
                <span className="hub-wing-tag hub-wing-tag--blue">LEARNING LAB</span>
              </div>
              <div className="hub-wing-body">
                <h3>TechVibes & Hands-On Workshops</h3>
                <p>
                  Interactive, weekend and evening bootcamps introducing coding, generative AI, robotics prototyping, and multimedia storytelling to youth and community members.
                </p>
              </div>
            </div>

            {/* Wing 3: Incubator */}
            <div className="hub-wing-card">
              <div className="hub-wing-img-wrap">
                <img src={incubatorImg} alt="Incubator & Venture Studio" className="hub-wing-img" />
                <span className="hub-wing-tag hub-wing-tag--purple">VENTURE STUDIO</span>
              </div>
              <div className="hub-wing-body">
                <h3>Venture Incubator & Accelerator</h3>
                <p>
                  Structured 3–6 month cohort programs providing business modeling, pitch coaching, legal incorporation support, and direct seed grant disbursements to youth founders.
                </p>
              </div>
            </div>

            {/* Wing 4: Creator Space */}
            <div className="hub-wing-card">
              <div className="hub-wing-img-wrap">
                <img src={boardroomImg} alt="Boardroom & Events" className="hub-wing-img" />
                <span className="hub-wing-tag hub-wing-tag--green">MEETING & EVENT SPACE</span>
              </div>
              <div className="hub-wing-body">
                <h3>Executive Boardroom & Event Hall</h3>
                <p>
                  Host hackathons, product launches, panel discussions, and stakeholder roundtables with presentation screens and recording equipment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Amenities Grid */}
      <section className="hub-amenities-section">
        <div className="container">
          <div className="hub-section-header text-center">
            <span className="section-pill">EVERYTHING YOU NEED</span>
            <h2>Built for Maximum Productivity</h2>
            <p>Designed from the ground up to remove friction so you can focus on building.</p>
          </div>

          <div className="hub-amenities-grid">
            {amenities.map((item, idx) => (
              <div key={idx} className="hub-amenity-card">
                <div className="hub-amenity-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Membership Passes */}
      <section className="hub-pricing-section" id="passes">
        <div className="container">
          <div className="hub-section-header text-center">
            <span className="section-pill">AFFORDABLE ACCESS</span>
            <h2>Flexible Membership Passes</h2>
            <p>Subsidized and accessible rates for youth builders, freelance creatives, and early-stage teams.</p>
          </div>

          <div className="hub-pricing-grid">
            {passes.map((pass, idx) => (
              <div key={idx} className={`hub-price-card ${pass.popular ? 'hub-price-card--popular' : ''}`}>
                {pass.popular && <span className="hub-price-popular-badge">MOST POPULAR</span>}
                <div className="hub-price-header">
                  <h3 className="hub-price-tier">{pass.tier}</h3>
                  <div className="hub-price-amount">
                    <span className="hub-price-val">{pass.price}</span>
                    <span className="hub-price-period">{pass.period}</span>
                  </div>
                  <p className="hub-price-desc">{pass.desc}</p>
                </div>

                <ul className="hub-price-features">
                  {pass.features.map((feat, fIdx) => (
                    <li key={fIdx}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      {feat}
                    </li>
                  ))}
                </ul>

                <Link to="/contact" className={`btn ${pass.popular ? 'btn-accent' : 'btn-outline-dark'} hub-price-btn`}>
                  {pass.cta}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experience / Photo Spotlight Banner */}
      <section className="hub-spotlight-section">
        <div className="container">
          <div className="hub-spotlight-box">
            <div className="hub-spotlight-img-wrap">
              <img src={dscImg} alt="Community collaborating in hub" className="hub-spotlight-img" />
            </div>
            <div className="hub-spotlight-body">
              <span className="section-pill">COMMUNITY FIRST</span>
              <h2>More than a desk. A family of builders.</h2>
              <p>
                When you join YOCILAB Hub, you join a supportive pan-African ecosystem of software developers, climate pioneers, artists, and social entrepreneurs working under one roof.
              </p>
              <div className="hub-spotlight-actions">
                <Link to="/contact" className="btn btn-primary">
                  Book a Visit
                </Link>
                <Link to="/programs/abeta" className="btn btn-secondary">
                  Join Online Platform
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YociLabHub;